export default "__VITE_ASSET__CMIrG9IO__"